/**
 * Created by sasik on 12/2/15.
 */

//$('.my-colorpicker').colorpicker();

$(".email-validator").each(function(i,el){
    var $el=$(el);
    var $zmdi=$el.find(".zmdi");//
    var setSuccess=function(iset,val){
        if(val!==undefined && val==="")
            return ($el.removeClass("has-error").removeClass("has-success") & $zmdi.removeClass("zmdi-close").removeClass("zmdi-check"));
        if(iset)
            $el.removeClass("has-error").addClass("has-success")& $zmdi.removeClass("zmdi-close").addClass("zmdi-check");
        else
            $el.addClass("has-error").removeClass("has-success")& $zmdi.addClass("zmdi-close").removeClass("zmdi-check");
    };
    $el.find("input").on("keyup change",function(){
        setSuccess((/\S+@\S+/).test($(this).val()));
    });
    setSuccess((/\S+@\S+/).test($el.find("input").val()),$el.find("input").val());
});
